import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Dashboard } from './Dashboard';
import { Home } from './Home';
import { Profile } from './Profile';
import { Achievement } from './Achievement';
import { Blog } from './Blog';
import { Hub } from './Hub';
import { Membership } from './Membership';
import { BlogPage } from '../components/Blog/BlogPage';

function App() {
  return (
    <div>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/profile/:id" element={<Profile />} />
          <Route path="/achievement" element={<Achievement />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPage />} />
          <Route path="/hub" element={<Hub />} />
          <Route path="/membership" element={<Membership />} />
        </Routes>
      </div>
    </div>
  );
}
export default App;
